import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { AssetDistributionCard, AssetSummary } from '../../components';

export class DistributionTab extends Component {
  render() {
    const assets = this.props.assets.data;
    const chartRows = [
      {
        type: 'active',
        sum: assets.summary.active
      },
      {
        type: 'expired',
        sum: assets.summary.expired
      }
    ];

    return (
      <div>
        <AssetSummary
          summary={assets.summary}
          chartRows={chartRows}
          source="distribution"
          {...this.props}
        />
        <AssetDistributionCard
          actions={this.props.actions}
          assets={assets}
          rules={this.props.rules}
          toast={this.props.toast}
        />
      </div>
    );
  }
}

DistributionTab.propTypes = {
  location: PropTypes.object
};

export default injectIntl(DistributionTab);
